<div class="fixed-bottom flex flex-col space-y-2">
    @if (!isCollapsed) {
        <div class="flex flex-col px-3 pb-2 space-y-2">
            <button mat-raised-button secondary thin (click)="logout()">
                Logout
            </button>
            <app-sidenav-bottom-panel-info></app-sidenav-bottom-panel-info>
        </div>
    }
</div>
